'use client';

import { AlertCircle } from 'lucide-react';
import posthog from 'posthog-js';
import { useEffect } from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    // Log the error to an error reporting service
    console.error('CRITICAL ERROR', error);
    if (process.env.NEXT_PUBLIC_VERCEL_ENV === 'production') {
      posthog.captureException(error);
    }
  }, [error]);

  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Alert variant="destructive">
          <AlertCircle className="h-4 w-4" />
          <AlertTitle className="font-semibold text-lg">Error</AlertTitle>
          <AlertDescription>
            {'Something went wrong! Please refresh the page to try again.'}
          </AlertDescription>
          <Button
            className="mt-4 w-full shadow-none"
            onClick={reset}
            variant="destructive"
          >
            Try again
          </Button>
        </Alert>
      </div>
    </div>
  );
}
